import { render, staticRenderFns } from "./OrderTabDetails.vue?vue&type=template&id=7beb9638&scoped=true"
import script from "./OrderTabDetails.vue?vue&type=script&lang=ts"
export * from "./OrderTabDetails.vue?vue&type=script&lang=ts"
import style0 from "./OrderTabDetails.vue?vue&type=style&index=0&id=7beb9638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beb9638",
  null
  
)

export default component.exports